import { HomePageState } from ".";
export const HomePageInitialState: HomePageState = {
  searchDepartmentId: "",
  searchResult: {
    myProjectList: [],
    myTodoList: [],
  },
};
